import { render, staticRenderFns } from "./deliveryTime.vue?vue&type=template&id=0853c1f0&scoped=true"
import script from "./deliveryTime.vue?vue&type=script&lang=js"
export * from "./deliveryTime.vue?vue&type=script&lang=js"
import style0 from "./deliveryTime.vue?vue&type=style&index=0&id=0853c1f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0853c1f0",
  null
  
)

export default component.exports